import { useState, useEffect } from 'react';
import api from '@/shared/api';
import config from '@/config';
var useFiscalRealEstates = function (relationId) {
    var _a = useState([]), realEstates = _a[0], setRealEstates = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        api.base
            .get("".concat(config.appUrls.api, "/api/Fiscal/realEstates/").concat(relationId))
            .then(function (_a) {
            var data = _a.data;
            setRealEstates(data || []);
            setLoading(false);
        })
            .catch(function () {
            setLoading(false);
        });
    }, [relationId]);
    return { realEstates: realEstates, loading: loading };
};
export default useFiscalRealEstates;
